export default __webpack_public_path__ + "static/media/imag1.c69215c2.jpg";